import { render, staticRenderFns } from "./CourseRow.vue?vue&type=template&id=754e1222&"
import script from "./CourseRow.vue?vue&type=script&lang=js&"
export * from "./CourseRow.vue?vue&type=script&lang=js&"
import style0 from "./CourseRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports